module.exports = __webpack_public_path__ + "img/millet.4f59d8a7.jpg";